import { AppBar, Toolbar as MUIToolbar } from '@mui/material';
import styled from 'styled-components';

// Thin framing strip above the content panel — no content.
const Toolbar = styled(MUIToolbar)`
  && {
    height: ${({ theme }) => theme.spacing(2)};
    min-height: ${({ theme }) => theme.spacing(2)};
  }
`;

const StyledAppBar = styled(AppBar)`
  && {
    background-color: ${({ theme }) => theme.palette.background.default};
    background-image: none;
    box-shadow: none;
    color: ${({ theme }) => theme.palette.gray.main};
    width: 100%;
    flex-shrink: 0;
  }
`;

export { StyledAppBar, Toolbar };
